import { useOutstandingTransactionsComingSoonState } from '../../outstanding-transactions-coming-soon-routing/hooks/useOutstandingTransactionsComingSoonState/useOutstandingTransactionsComingSoonState'
import { OutstandingTransactionsComingSoonModalContent } from './OutstandingTransactionsComingSoonModalContent/OutstandingTransactionsComingSoonModalContent'

export const OutstandingTransactionsComingSoonModal = () => {
  const { state } = useOutstandingTransactionsComingSoonState()

  if (state === null) {
    return null
  }

  return <OutstandingTransactionsComingSoonModalContent />
}
